export default __webpack_public_path__ + "static/media/main_bg.43d8d9b7.png";